import { render, staticRenderFns } from "./CopVehiculos.vue?vue&type=template&id=1a6c74cd&scoped=true"
import script from "./CopVehiculos.vue?vue&type=script&lang=js"
export * from "./CopVehiculos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6c74cd",
  null
  
)

export default component.exports